import { useState as s } from "react";
const c = ({ langHandler: e }) => {
  const [o, a] = s(!1);
  return {
    showLanguageModal: o,
    handleLanguageChange: (n) => {
      a(!1), e == null || e(n);
    },
    onCloseHandler: () => a(!1),
    languageClickHandler: () => a(!o)
  };
};
export {
  c as default
};
//# sourceMappingURL=useLanguageSelector.js.map
